const productFilterForm = document.getElementById("product-filters");

if (productFilterForm) {
    initProductFilters();
}

function initProductFilters() {
    setUpApplyButtons();

    setUpExpandsets();

    setUpClearAll();

    setUpClearFilterChips();
}

function setUpApplyButtons() {
    const inputs = productFilterForm.querySelectorAll(
        "input[type='checkbox'], input[type='radio']",
    );

    inputs.forEach((input) => {
        input.addEventListener("change", () => {
            const formGroup = input.closest(".product-filters-section");

            if (formGroup) {
                formGroup
                    .querySelectorAll("[data-show-apply]")
                    .forEach((element) => {
                        element.setAttribute("data-show-apply", true);
                    });
            }
        });
    });
}

function setUpExpandsets() {
    const expandsets = productFilterForm.querySelectorAll(
        ".product-filters-section details",
    );

    expandsets.forEach((expandset) => {
        const hasSelected = expandset.querySelector(
            "input[type='checkbox']:checked, input[type='radio']:checked",
        );

        if (hasSelected) {
            expandset.setAttribute("open", true);
            expandset.classList.add("is-open");
        }
    });
}

function setUpClearAll() {
    const clearAllLink = productFilterForm.querySelector("[data-clear-all]");

    clearAllLink?.addEventListener("click", (event) => {
        event.preventDefault();
        window.location = window.location.href.split("?")[0];
    });

    if (clearAllLink) {
        clearAllLink.setAttribute("href", "/products");
    }
}

function setUpClearFilterChips() {
    const filterChips = productFilterForm.querySelectorAll(
        ".filter-chip-remove",
    );

    filterChips.forEach((chip) => {
        chip.addEventListener("click", (event) => {
            event.preventDefault();
            const filterKey = chip.getAttribute("data-filter-key");
            const filterValue = chip.getAttribute("data-filter-value");

            if (filterKey && filterValue) {
                const url = new URL(window.location.href);
                url.searchParams.set(
                    filterKey,
                    url.searchParams.get(filterKey).replace(filterValue, ""),
                );

                if (url.searchParams.get(filterKey) === "") {
                    url.searchParams.delete(filterKey);
                }
                window.location = url.toString();
            }
        });
    });
}
